import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../../utils/api.js";

const MallData = () => {
  const [formData, setFormData] = useState({
    basicMallInformation: {
      mallName: "",
      mallType: "",
      totalFloorArea: 0,
      numberOfFloors: 0,
      numberOfStores: 0,
      accreditations: [],
    },
    dataCollectionDetails: {
      dateOfDataCollection: "",
      dataCollectedBy: "",
      dataSource: "",
    },
    mallLayoutTrafficFlow: {
      averageDailyFootfall: 0,
      peakHoursOfFootfall: [],
      totalEntrancesExits: 0,
      numberOfEscalatorsElevators: 0,
      totalFoodCourts: 0,
      numberOfRestrooms: 0,
      seatingLoungeAreas: false,
      cinemaTheater: false,
      kidsPlayArea: false,
    },
    cleaningDisinfectionPractices: {
      totalCleaningBudget: 0,
      disinfectionCostcommonAreas: 0,
      disinfectionCostfoodCourt: 0,
      disinfectionCostrestrooms: 0,
      disinfectionCostseatingAreas: 0,
      currentDisinfectionMethods: [],
      disinfectionFrequencyPerAreaPerDay: 0,
      manualDisinfectionTime: 0,
      disinfectionChallenges: [],
    },
    healthSafetyCompliance: {
      regulatoryStandards: "",
      auditFrequency: [],
      visitorComplaints: {
        hasComplaints: false,
        details: [],
      },
    },
    staffAutomationReadiness: {
      housekeepingStaff: "",
      cleaningStaffShiftHours: "",
      ppeUsage: false,
      automationReadiness: false,
      concernsUV_CUsage: false,
    },
    timeCostEfficiencyUVCRobot: {
      manualDisinfectionTimePerDay: 0,
      disinfectionConsumableCost: 0,
      laborCost: 0,
      complaintCost: 0,
      electricityConsumption: 0,
    },
    integrationCustomizationNeeds: {
      existingMallITSystem: false,
      integrationNeeds: [],
      preferredFinancialModel: "",
      customizationNeeds: [],
    },
    demonstrationNextSteps: {
      interestInDemo: false,
      pilotProjectReadiness: false,
      keyDecisionMaker: "",
      decisionMakingTimeline: [],
    },
    additionalnotes: {
      note: "",
    },
  });

  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const FORM_STEPS = [
    "Basic Mall Information",
    "Data Collection Details",
    "Mall Layout and Traffic Flow",
    "Cleaning and Disinfection Practices",
    "Health & Safety Compliance",
    "Staff-Automation Readiness",
    "Time & Cost Efficiency of UVC Robot",
    "Integration & Customization Needs",
    "Demonstration & Next Steps",
    "Additional Notes",
  ];
  const totalSteps = FORM_STEPS.length;

  const pageStyle = {
    position: "relative",
    minHeight: "100vh",
    background:
      "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: "24px 32px 48px",
    boxSizing: "border-box",
  };
  const cardStyle = {
    maxWidth: 720,
    margin: "0 auto 24px",
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    padding: 28,
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  };
  const inputGroupStyle = { marginBottom: 18 };
  const labelStyle = {
    display: "block",
    marginBottom: 6,
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#64748b",
  };
  const inputStyle = {
    width: "100%",
    padding: "0.65rem 0.85rem",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: "1rem",
    outline: "none",
    boxSizing: "border-box",
  };
  const sectionTitleStyle = {
    margin: "0 0 20px",
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#1e293b",
  };

  const handleChange = (e, section, nestedSection) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    if (type === "number") {
      newValue = Math.max(0, Number(value)) || 0;
    } else if (type === "checkbox") {
      newValue = checked; // Convert to boolean
    } else if (
      type === "text" &&
      (name === "peakHoursOfFootfall" ||
        name === "currentDisinfectionMethods" ||
        name === "disinfectionChallenges")
    ) {
      // Handle array input for fields that expect arrays
      newValue = value.split(",").map((item) => item.trim());
    }

    if (nestedSection) {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [nestedSection]: {
            ...prevData[section][nestedSection],
            [name]: newValue,
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [section]: {
          ...prevData[section],
          [name]: newValue,
        },
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post("/post-mall-data", formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Add auth token
          "Content-Type": "application/json",
        },
      });

      console.log("Data posted successfully:", response.data);
      alert("Mall data submitted successfully!");
      navigate("/Malldetails");
      // Reset form after successful submission
      setFormData({
        basicMallInformation: {
          mallName: "",
          mallType: "",
          totalFloorArea: 0,
          numberOfFloors: 0,
          numberOfStores: 0,
          accreditations: [],
        },
        dataCollectionDetails: {
          dateOfDataCollection: "",
          dataCollectedBy: "",
          dataSource: "",
        },
        mallLayoutTrafficFlow: {
          averageDailyFootfall: 0,
          peakHoursOfFootfall: [],
          totalEntrancesExits: 0,
          numberOfEscalatorsElevators: 0,
          totalFoodCourts: 0,
          numberOfRestrooms: 0,
          seatingLoungeAreas: false,
          cinemaTheater: false,
          kidsPlayArea: false,
        },
        cleaningDisinfectionPractices: {
          totalCleaningBudget: 0,
          disinfectionCostcommonAreas: 0,
          disinfectionCostfoodCourt: 0,
          disinfectionCostrestrooms: 0,
          disinfectionCostseatingAreas: 0,
          currentDisinfectionMethods: [],
          disinfectionFrequencyPerAreaPerDay: 0,
          manualDisinfectionTime: 0,
          disinfectionChallenges: [],
        },
        healthSafetyCompliance: {
          regulatoryStandards: "",
          auditFrequency: [],
          visitorComplaints: {
            hasComplaints: false,
            details: [],
          },
        },
        staffAutomationReadiness: {
          housekeepingStaff: "",
          cleaningStaffShiftHours: "",
          ppeUsage: false,
          automationReadiness: false,
          concernsUV_CUsage: false,
        },
        timeCostEfficiencyUVCRobot: {
          manualDisinfectionTimePerDay: 0,
          disinfectionConsumableCost: 0,
          laborCost: 0,
          complaintCost: 0,
          electricityConsumption: 0,
        },
        integrationCustomizationNeeds: {
          existingMallITSystem: false,
          integrationNeeds: [],
          preferredFinancialModel: "",
          customizationNeeds: [],
        },
        demonstrationNextSteps: {
          interestInDemo: false,
          pilotProjectReadiness: false,
          keyDecisionMaker: "",
          decisionMakingTimeline: [],
        },
        additionalnotes: {
          note: "",
        },
      });
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
      alert("Failed to submit mall data.");
    }
  };

  return (
    <div style={pageStyle}>
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 20, marginBottom: 28 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Mall Data Form
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Complete the sections below. Use Previous and Next to move between steps.
        </p>
      </div>

      <div
        style={{
          maxWidth: 720,
          margin: "0 auto 20px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        {FORM_STEPS.map((name, i) => (
          <span
            key={i}
            style={{
              padding: "6px 12px",
              borderRadius: 8,
              fontSize: "0.8rem",
              fontWeight: 500,
              background:
                currentStep === i
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "#e2e8f0",
              color: currentStep === i ? "#fff" : "#64748b",
            }}
          >
            {name}
          </span>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <div style={cardStyle}>
          {currentStep === 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Basic Mall Information</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 1 of {totalSteps}
                </p>
              </div>
          {[
            { label: "Mall Name", name: "mallName", type: "text" },
            {
              label: "Mall Type",
              name: "mallType",
              type: "select",
              options: ["Luxury", "Regular", "Outlet"],
            },
            {
              label: "Total Floor Area",
              name: "totalFloorArea",
              type: "number",
            },
            {
              label: "Number of Floors",
              name: "numberOfFloors",
              type: "number",
            },
            {
              label: "Number of Stores",
              name: "numberOfStores",
              type: "number",
            },
            {
              label: "Accreditations",
              name: "accreditations",
              type: "text",
            },
          ].map(({ label, name, type, options }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              {type === "select" ? (
                <select
                  name={name}
                  value={formData.basicMallInformation[name] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    handleChange(
                      { target: { name, value: val } },
                      "basicMallInformation"
                    );
                  }}
                  style={inputStyle}
                >
                  <option value="">Select {label}</option>
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={type}
                  name={name}
                  placeholder={
                    type === "number"
                      ? "Enter a number"
                      : "Enter " + label.toLowerCase()
                  }
                  value={formData.basicMallInformation[name] || ""}
                  onChange={(e) => {
                    const val =
                      type === "number"
                        ? Math.max(0, Number(e.target.value)) || 0
                        : e.target.value;
                    handleChange(
                      { target: { name, value: val } },
                      "basicMallInformation"
                    );
                  }}
                  style={inputStyle}
                />
              )}
            </div>
          ))}
            </>
          )}

          {currentStep === 1 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Data Collection Details</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 2 of {totalSteps}
                </p>
              </div>
          {[
            {
              label: "Date of Data Collection",
              name: "dateOfDataCollection",
              type: "date",
            },
            {
              label: "Data Collected By",
              name: "dataCollectedBy",
              type: "text",
            },
            {
              label: "Data Source",
              name: "dataSource",
              type: "select",
              options: ["Mall Admin", "Facility Manager", "Security"],
            },
          ].map(({ label, name, type, options }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              {type === "select" ? (
                <select
                  name={name}
                  value={formData.dataCollectionDetails[name] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    handleChange(
                      { target: { name, value: val } },
                      "dataCollectionDetails"
                    );
                  }}
                  style={inputStyle}
                >
                  <option value="">Select {label}</option>
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={type}
                  name={name}
                  placeholder={"Enter " + label.toLowerCase()}
                  value={formData.dataCollectionDetails[name] || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    handleChange(
                      { target: { name, value: val } },
                      "dataCollectionDetails"
                    );
                  }}
                  style={inputStyle}
                />
              )}
            </div>
          ))}
            </>
          )}

          {currentStep === 2 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Mall Layout and Traffic Flow</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 3 of {totalSteps}
                </p>
              </div>
          {[
            {
              label: "Average Daily Footfall",
              name: "averageDailyFootfall",
              type: "number",
            },
            {
              label: "Peak Hours of Footfall (comma-separated)",
              name: "peakHoursOfFootfall",
              type: "text",
            },
            {
              label: "Total Entrances/Exits",
              name: "totalEntrancesExits",
              type: "number",
            },
            {
              label: "Number of Escalators/Elevators",
              name: "numberOfEscalatorsElevators",
              type: "number",
            },
            {
              label: "Total Food Courts",
              name: "totalFoodCourts",
              type: "number",
            },
            {
              label: "Number of Restrooms",
              name: "numberOfRestrooms",
              type: "number",
            },
          ].map(({ label, name, type }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder={
                  type === "number"
                    ? "Enter a number"
                    : "Enter " + label.toLowerCase()
                }
                value={formData.mallLayoutTrafficFlow[name] || ""}
                onChange={(e) => {
                  const val =
                    type === "number"
                      ? Math.max(0, Number(e.target.value)) || 0
                      : e.target.value;
                  handleChange(
                    { target: { name, value: val } },
                    "mallLayoutTrafficFlow"
                  );
                }}
                style={inputStyle}
              />
            </div>
          ))}

          {/* Radio Button Fields */}
          {[
            { label: "Seating/Lounge Areas", name: "seatingLoungeAreas" },
            { label: "Cinema/Theater", name: "cinemaTheater" },
            { label: "Kids Play Area", name: "kidsPlayArea" },
          ].map(({ label, name }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <div style={{ display: "flex", gap: "15px" }}>
                {/* Yes Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name={name}
                    value="true"
                    checked={formData.mallLayoutTrafficFlow[name] === true}
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        mallLayoutTrafficFlow: {
                          ...prevData.mallLayoutTrafficFlow,
                          [name]: true,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "green" }}>
                    Yes
                  </span>
                </label>

                {/* No Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name={name}
                    value="false"
                    checked={formData.mallLayoutTrafficFlow[name] === false}
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        mallLayoutTrafficFlow: {
                          ...prevData.mallLayoutTrafficFlow,
                          [name]: false,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "red" }}>No</span>
                </label>
              </div>
            </div>
          ))}
            </>
          )}

          {currentStep === 3 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Cleaning and Disinfection Practices</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 4 of {totalSteps}
                </p>
              </div>
          {[
            {
              label: "Total Cleaning Budget",
              name: "totalCleaningBudget",
              type: "number",
            },
            {
              label: "Disinfection Cost (Common Areas)",
              name: "disinfectionCostcommonAreas",
              type: "number",
            },
            {
              label: "Disinfection Cost (Food Court)",
              name: "disinfectionCostfoodCourt",
              type: "number",
            },
            {
              label: "Disinfection Cost (Restrooms)",
              name: "disinfectionCostrestrooms",
              type: "number",
            },
            {
              label: "Disinfection Cost (Seating Areas)",
              name: "disinfectionCostseatingAreas",
              type: "number",
            },
            {
              label: "Current Disinfection Methods (comma-separated)",
              name: "currentDisinfectionMethods",
              type: "text",
            },
            {
              label: "Disinfection Frequency Per Area Per Day",
              name: "disinfectionFrequencyPerAreaPerDay",
              type: "number",
            },
            {
              label: "Manual Disinfection Time (in hours)",
              name: "manualDisinfectionTime",
              type: "number",
            },
            {
              label: "Disinfection Challenges (comma-separated)",
              name: "disinfectionChallenges",
              type: "text",
            },
          ].map(({ label, name, type }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder={
                  type === "number"
                    ? "Enter a number"
                    : "Enter " + label.toLowerCase()
                }
                value={formData.cleaningDisinfectionPractices[name] || ""}
                onChange={(e) => {
                  const val =
                    type === "number"
                      ? Math.max(0, Number(e.target.value)) || 0
                      : e.target.value;
                  handleChange(
                    { target: { name, value: val } },
                    "cleaningDisinfectionPractices"
                  );
                }}
                style={inputStyle}
              />
            </div>
          ))}
            </>
          )}

          {currentStep === 4 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Health & Safety Compliance</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 5 of {totalSteps}
                </p>
              </div>
          {/* Regulatory Standards Dropdown */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Regulatory Standards</label>
            <select
              name="regulatoryStandards"
              value={formData.healthSafetyCompliance.regulatoryStandards}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  healthSafetyCompliance: {
                    ...prevData.healthSafetyCompliance,
                    regulatoryStandards: value,
                  },
                }));
              }}
              style={inputStyle}
              required
            >
              <option value="">Select Regulatory Standard</option>
              <option value="WHO">WHO</option>
              <option value="Local Govt.">Local Govt.</option>
              <option value="Mall Associations">Mall Associations</option>
            </select>
          </div>

          {/* Audit Frequency (Comma-separated) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Audit Frequency (comma-separated)
            </label>
            <input
              type="text"
              name="auditFrequency"
              placeholder="e.g., Monthly, Quarterly"
              value={formData.healthSafetyCompliance.auditFrequency.join(", ")}
              onChange={(e) => {
                const value = e.target.value
                  .split(",")
                  .map((item) => item.trim());
                setFormData((prevData) => ({
                  ...prevData,
                  healthSafetyCompliance: {
                    ...prevData.healthSafetyCompliance,
                    auditFrequency: value,
                  },
                }));
              }}
              style={inputStyle}
            />
          </div>

          {/* Visitor Complaints Radio Buttons */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Visitor Complaints</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="hasComplaints"
                  value="true"
                  checked={
                    formData.healthSafetyCompliance.visitorComplaints
                      .hasComplaints === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      healthSafetyCompliance: {
                        ...prevData.healthSafetyCompliance,
                        visitorComplaints: {
                          ...prevData.healthSafetyCompliance.visitorComplaints,
                          hasComplaints: true,
                        },
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="hasComplaints"
                  value="false"
                  checked={
                    formData.healthSafetyCompliance.visitorComplaints
                      .hasComplaints === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      healthSafetyCompliance: {
                        ...prevData.healthSafetyCompliance,
                        visitorComplaints: {
                          ...prevData.healthSafetyCompliance.visitorComplaints,
                          hasComplaints: false,
                          details: [], // Clear details if 'No' is selected
                        },
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Complaint Details (Conditional) */}
          {formData.healthSafetyCompliance.visitorComplaints.hasComplaints && (
            <div style={inputGroupStyle}>
              <label style={labelStyle}>
                Complaint Details (comma-separated)
              </label>
              <input
                type="text"
                name="details"
                placeholder="e.g., cleanliness, safety hazards"
                value={formData.healthSafetyCompliance.visitorComplaints.details.join(
                  ", "
                )}
                onChange={(e) => {
                  const value = e.target.value
                    .split(",")
                    .map((item) => item.trim());
                  setFormData((prevData) => ({
                    ...prevData,
                    healthSafetyCompliance: {
                      ...prevData.healthSafetyCompliance,
                      visitorComplaints: {
                        ...prevData.healthSafetyCompliance.visitorComplaints,
                        details: value,
                      },
                    },
                  }));
                }}
                style={inputStyle}
              />
            </div>
          )}
            </>
          )}

          {currentStep === 5 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Staff-Automation Readiness</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 6 of {totalSteps}
                </p>
              </div>
          {/* Housekeeping Staff */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Housekeeping Staff</label>
            <input
              type="number"
              name="housekeepingStaff"
              value={formData.staffAutomationReadiness.housekeepingStaff || ""}
              onChange={(e) => handleChange(e, "staffAutomationReadiness")}
              style={inputStyle}
              placeholder="Enter number of housekeeping staff"
            />
          </div>

          {/* Cleaning Staff Shift Hours */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Cleaning Staff Shift Hours</label>
            <input
              type="number"
              name="cleaningStaffShiftHours"
              value={
                formData.staffAutomationReadiness.cleaningStaffShiftHours || ""
              }
              onChange={(e) => handleChange(e, "staffAutomationReadiness")}
              style={inputStyle}
              placeholder="Enter shift hours"
            />
          </div>

          {/* PPE Usage Radio Buttons */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>PPE Usage</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="ppeUsage"
                  value="true"
                  checked={formData.staffAutomationReadiness.ppeUsage === true}
                  onChange={() =>
                    handleChange(
                      { target: { name: "ppeUsage", value: true } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="ppeUsage"
                  value="false"
                  checked={formData.staffAutomationReadiness.ppeUsage === false}
                  onChange={() =>
                    handleChange(
                      { target: { name: "ppeUsage", value: false } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Automation Readiness Radio Buttons */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Automation Readiness</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="automationReadiness"
                  value="true"
                  checked={
                    formData.staffAutomationReadiness.automationReadiness ===
                    true
                  }
                  onChange={() =>
                    handleChange(
                      { target: { name: "automationReadiness", value: true } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="automationReadiness"
                  value="false"
                  checked={
                    formData.staffAutomationReadiness.automationReadiness ===
                    false
                  }
                  onChange={() =>
                    handleChange(
                      { target: { name: "automationReadiness", value: false } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Concerns with UV-C Usage Radio Buttons */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Concerns with UV-C Usage</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="concernsUV_CUsage"
                  value="true"
                  checked={
                    formData.staffAutomationReadiness.concernsUV_CUsage === true
                  }
                  onChange={() =>
                    handleChange(
                      { target: { name: "concernsUV_CUsage", value: true } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="concernsUV_CUsage"
                  value="false"
                  checked={
                    formData.staffAutomationReadiness.concernsUV_CUsage ===
                    false
                  }
                  onChange={() =>
                    handleChange(
                      { target: { name: "concernsUV_CUsage", value: false } },
                      "staffAutomationReadiness"
                    )
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>
            </>
          )}

          {currentStep === 6 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Time & Cost Efficiency of UVC Robot</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 7 of {totalSteps}
                </p>
              </div>
          {[
            {
              label: "Manual Disinfection Time Per Day (hours)",
              name: "manualDisinfectionTimePerDay",
              type: "number",
            },
            {
              label: "Disinfection Consumable Cost",
              name: "disinfectionConsumableCost",
              type: "number",
            },
            {
              label: "Labor Cost",
              name: "laborCost",
              type: "number",
            },
            {
              label: "Complaint Cost",
              name: "complaintCost",
              type: "number",
            },
            {
              label: "Electricity Consumption (kWh)",
              name: "electricityConsumption",
              type: "number",
            },
          ].map(({ label, name, type }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder={`Enter ${label.toLowerCase()}`}
                value={formData.timeCostEfficiencyUVCRobot[name] || ""}
                onChange={(e) => {
                  const val =
                    type === "number"
                      ? Math.max(0, Number(e.target.value)) || 0
                      : e.target.value;
                  handleChange(
                    { target: { name, value: val } },
                    "timeCostEfficiencyUVCRobot"
                  );
                }}
                style={inputStyle}
              />
            </div>
          ))}
            </>
          )}

          {currentStep === 7 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Integration & Customization Needs</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 8 of {totalSteps}
                </p>
              </div>
          {/* Existing Mall IT System Checkbox */}
          <div style={inputGroupStyle}>
            {/* Existing Mall IT System Radio Buttons */}
            <div style={inputGroupStyle}>
              <label style={labelStyle}>Existing Mall IT System</label>
              <div style={{ display: "flex", gap: "15px" }}>
                {/* Yes Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="existingMallITSystem"
                    value="true"
                    checked={
                      formData.integrationCustomizationNeeds
                        .existingMallITSystem === true
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        integrationCustomizationNeeds: {
                          ...prevData.integrationCustomizationNeeds,
                          existingMallITSystem: true,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "green" }}>
                    Yes
                  </span>
                </label>

                {/* No Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="existingMallITSystem"
                    value="false"
                    checked={
                      formData.integrationCustomizationNeeds
                        .existingMallITSystem === false
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        integrationCustomizationNeeds: {
                          ...prevData.integrationCustomizationNeeds,
                          existingMallITSystem: false,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "red" }}>No</span>
                </label>
              </div>
            </div>
          </div>

          {/* Integration Needs (Comma-separated) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Integration Needs (comma-separated)
            </label>
            <input
              type="text"
              name="integrationNeeds"
              placeholder="e.g., API integration, data synchronization"
              value={formData.integrationCustomizationNeeds.integrationNeeds.join(
                ", "
              )}
              onChange={(e) => {
                const value = e.target.value
                  .split(",")
                  .map((item) => item.trim());
                setFormData((prevData) => ({
                  ...prevData,
                  integrationCustomizationNeeds: {
                    ...prevData.integrationCustomizationNeeds,
                    integrationNeeds: value,
                  },
                }));
              }}
              style={inputStyle}
            />
          </div>

          {/* Preferred Financial Model Dropdown */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Preferred Financial Model</label>
            <select
              name="preferredFinancialModel"
              value={
                formData.integrationCustomizationNeeds.preferredFinancialModel
              }
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  integrationCustomizationNeeds: {
                    ...prevData.integrationCustomizationNeeds,
                    preferredFinancialModel: value,
                  },
                }));
              }}
              style={inputStyle}
              required
            >
              <option value="">Select Financial Model</option>
              <option value="Buy">Buy</option>
              <option value="Lease">Lease</option>
              <option value="Subscription">Subscription</option>
            </select>
          </div>

          {/* Customization Needs (Comma-separated) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Customization Needs (comma-separated)
            </label>
            <input
              type="text"
              name="customizationNeeds"
              placeholder="e.g., branding, specific features"
              value={formData.integrationCustomizationNeeds.customizationNeeds.join(
                ", "
              )}
              onChange={(e) => {
                const value = e.target.value
                  .split(",")
                  .map((item) => item.trim());
                setFormData((prevData) => ({
                  ...prevData,
                  integrationCustomizationNeeds: {
                    ...prevData.integrationCustomizationNeeds,
                    customizationNeeds: value,
                  },
                }));
              }}
              style={inputStyle}
            />
          </div>
            </>
          )}

          {currentStep === 8 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Demonstration & Next Steps</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 9 of {totalSteps}
                </p>
              </div>
          {/* Interest in Demo Checkbox */}
          <div style={inputGroupStyle}>
            {/* Interest in Demonstration Radio Buttons */}
            <div style={inputGroupStyle}>
              <label style={labelStyle}>Interest in Demonstration</label>
              <div style={{ display: "flex", gap: "15px" }}>
                {/* Yes Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="interestInDemo"
                    value="true"
                    checked={
                      formData.demonstrationNextSteps.interestInDemo === true
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        demonstrationNextSteps: {
                          ...prevData.demonstrationNextSteps,
                          interestInDemo: true,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "green" }}>
                    Yes
                  </span>
                </label>

                {/* No Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="interestInDemo"
                    value="false"
                    checked={
                      formData.demonstrationNextSteps.interestInDemo === false
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        demonstrationNextSteps: {
                          ...prevData.demonstrationNextSteps,
                          interestInDemo: false,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "red" }}>No</span>
                </label>
              </div>
            </div>
          </div>

          {/* Pilot Project Readiness Radio Buttons */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Pilot Project Readiness</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="true"
                  checked={
                    formData.demonstrationNextSteps.pilotProjectReadiness ===
                    true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demonstrationNextSteps: {
                        ...prevData.demonstrationNextSteps,
                        pilotProjectReadiness: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="false"
                  checked={
                    formData.demonstrationNextSteps.pilotProjectReadiness ===
                    false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demonstrationNextSteps: {
                        ...prevData.demonstrationNextSteps,
                        pilotProjectReadiness: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Key Decision Maker Dropdown */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Key Decision Maker</label>
            <select
              name="keyDecisionMaker"
              value={formData.demonstrationNextSteps.keyDecisionMaker}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  demonstrationNextSteps: {
                    ...prevData.demonstrationNextSteps,
                    keyDecisionMaker: value,
                  },
                }));
              }}
              style={inputStyle}
              required
            >
              <option value="">Select Decision Maker</option>
              <option value="Mall Manager">Mall Manager</option>
              <option value="Facility Director">Facility Director</option>
              <option value="Admin">Admin</option>
            </select>
          </div>

          {/* Decision Making Timeline (Comma-separated) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Decision Making Timeline (comma-separated)
            </label>
            <input
              type="text"
              name="decisionMakingTimeline"
              placeholder="e.g., 1-2 weeks, 1 month"
              value={formData.demonstrationNextSteps.decisionMakingTimeline.join(
                ", "
              )}
              onChange={(e) => {
                const value = e.target.value
                  .split(",")
                  .map((item) => item.trim());
                setFormData((prevData) => ({
                  ...prevData,
                  demonstrationNextSteps: {
                    ...prevData.demonstrationNextSteps,
                    decisionMakingTimeline: value,
                  },
                }));
              }}
              style={inputStyle}
            />
          </div>

            </>
          )}

          {currentStep === 9 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Additional Notes</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 10 of {totalSteps}
                </p>
              </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Notes</label>
            <textarea
              name="note"
              value={formData.additionalnotes.note}
              onChange={(e) => handleChange(e, "additionalnotes")}
              style={{
                width: "100%",
                minHeight: 120,
                padding: "0.65rem 0.85rem",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                fontSize: "1rem",
                outline: "none",
                boxSizing: "border-box",
                resize: "vertical",
              }}
              placeholder="Enter any additional notes here..."
            />
          </div>
            </>
          )}
        </div>

        <div
          style={{
            maxWidth: 720,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent:
              currentStep === 0 ? "flex-end" : "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          {currentStep > 0 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s - 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#64748b",
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              Previous
            </button>
          ) : (
            <span />
          )}
          {currentStep < totalSteps - 1 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s + 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Next
            </button>
          ) : (
            <button
              type="submit"
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default MallData;
